export enum AuthRoutesPaths {
  LOGIN = '/',
}

export enum AdminPanelRoutesPaths {
  CASES_LIST = '/cases',
  CASES_CREATE = '/cases/create',
  CASES_EDIT = '/cases/:id/edit',
  CASES_DETAILS = '/cases/:id',

  SEARCH = '/search',
  PENDING_CASES_LIST = '/pending-cases',
  MANAGE_LIST = '/manage-list',

  CLIENTS_LIST = '/clients',
  CLIENT_DETAILS = '/clients/:id',

  ORGANIZATION_TYPES_LIST = '/organization-types',

  ORDERS_LIST = '/orders',

  DAMAGES_LIST = '/damages',

  PROFILE = '/profile',
}
